<template>
<div class="flex images">

  <div class="hero">
    <img
      :src="hero_image.src"
      alt="Hero Image"
    >
  </div>

  <div class="thumbs">
    <button
      v-for="(thumb, index) of gallery"
      :key="index"
      class="thumb"
      :class="{ 'active' : thumb.id === hero_image.id }"
      @click="changeImage(thumb)"
    >
      <img :src="thumb.src" :alt="thumb.title">
    </button>
  </div>

</div>
</template>

<script>
export default {
  props: {
    gallery: Array
  },

  data () {
    return {
      hero_image: {},
      maxHeight: 100,
    }
  },

  mounted () {
    this.hero_image = this.gallery[0]

    if (screen.width < 768) {
      this.maxHeight =  120
    }
  },

  methods: {
    changeImage (obj) {
      this.hero_image = obj
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../sass/core/variables.scss";

.images {
  width: 100%;
  margin: 0 auto 20px;

  font-size: 0;

  //@media (min-width: $medium) { width: calc(50% - 10px); }
  @media (min-width: $mediumish) {
    width: 981px;
    margin: 0 auto;
  }

  @media (max-width: $smallish) {
    flex-direction: column-reverse;
  }

  .thumbs {
    display: inline-block;
    width: 67px;
    height: 224px;

    margin-left: 3px;

    overflow: auto;

    @media (max-width: $smallish) {
      display: flex;
      width: 100%;
      height: 95px;

      overflow-y: hidden;
    }

    @media (min-width: $mediumish) {
      width: 115px;
      height: 646px;
      margin-left: 6px;
    }

    .thumb {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 55px;
      height: 55px;
      margin: 0 0 10px;

      cursor: pointer;

      opacity: 0.6;

      @media (max-width: $smallish) {
        height: 85px;
        width: 85px;
        min-width: 85px;
        margin-right: 5px;
      }

      @media (min-width: $mediumish) {
        width: 100px;
        height: 100px;
      }

      img {
        height: 100%;
        width: 100%;
        margin: auto;
        object-fit: cover;
      }
    }

    .thumb.active { opacity: 1; }
  }

  .thumbs::-webkit-scrollbar {
    width: 80px;
    height: 8px;

    @media (min-width: $smallish) {
      width: 8px;
      height: 80px;
    }
  }


  .thumbs::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    background-color: white;
  }

  .thumbs::-webkit-scrollbar-thumb {
    background-color: #6b6f74;
    border-radius: 10px;
  }


  .hero {
    position: relative;
    display: inline-block;
    width: calc(100% - 70px);

    @media (max-width: $smallish) {
        width: 100%;
        margin-bottom: 10px;
    }

    @media (min-width: $mediumish) {
        display: flex;
        width: 860px;
        height: 646px;
    }

    img {
        margin: auto;
        max-height: 860px;
        min-height: 646px;
        object-fit: cover;
        height: 646px;

        @media (max-width: $smallish) {
            height: 300px;
        }
    }
  }

}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Gallery.vue